<div class="pipeline-card" *ngIf="entity">
    <div class="card disabled" [class.draggable]="draggable"
        [style.borderColor]="listColor">
        <div class="card-header pipeline-card-header d-flex flex-row" #pipelineCardHeader
            [style.backgroundColor]="listColor">
            <h5 class="card-title pipeline-card-title pipeline-card-title-numero">
                <span *ngIf="!config?.isSemCampanha">
                    # {{entity?.numero}}
                </span>
            </h5>

            <h5 *ngIf="!config?.isSemCampanha && entity.idArea" class="card-title pipeline-card-title pipeline-card-title-area">
                <sgt-area-label
                    [nome]="entity.nomeArea"
                    fontSize="10px">
                </sgt-area-label>
            </h5>
            
            <div class="pipeline-card-options" *ngIf="options?.hasAnyOption()">
                <div class="dropdown">
                    <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1">
                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-campanha">
                        <a class="dropdown-item" *ngIf="options?.canEdit" (click)="editClick()">
                            <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar
                        </a>

                        <a class="dropdown-item" *ngIf="options?.canVisualizar" (click)="visualizarClick()">
                            <i class="fas fa-search"></i> Visualizar
                        </a>                        

                        <ng-template [ngIf]="options?.hasAnyOptionAnalise()">
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Análise</h6>

                            <a class="dropdown-item dropdown-item-campanha-solicitar-analise" *ngIf="options?.canSolicitarAnalise" (click)="solicitarAnaliseClick()">
                                <i class="fas fa-gavel"></i> Solicitar Análise
                            </a>
                            <a class="dropdown-item dropdown-item-campanha-aprovar-analise" *ngIf="options?.canAprovarAnalise" (click)="aprovarAnaliseClick()">
                                <i class="far fa-thumbs-up"></i> Aprovar Campanha
                            </a>                            
                            <a class="dropdown-item dropdown-item-campanha-reprovar-analise" *ngIf="options?.canReprovarAnalise" (click)="reprovarAnaliseClick()">
                                <i class="far fa-thumbs-down"></i> Reprovar Campanha
                            </a>
                        </ng-template> 
                        
                        <ng-template [ngIf]="options?.hasAnyOptionEncerramento()">
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Encerramento</h6>

                            <a class="dropdown-item dropdown-item-campanha-encerrar" *ngIf="options?.canEncerrar" (click)="encerrarClick()">
                                <i class="fas fa-check-double"></i> Encerrar Campanha
                            </a>
                        </ng-template>   
                        
                        <ng-template [ngIf]="options?.hasAnyOptionPedido()">
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Pedidos</h6>

                            <a class="dropdown-item dropdown-item-warning" *ngIf="options?.canLiberarPedidos" (click)="liberarPedidosClick()">
                                <i class="far fa-thumbs-up"></i> Abrir Liberação de Pedido(s)
                            </a>                        
                        </ng-template>
                        
                        <ng-template [ngIf]="options?.canDelete">
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dropdown-item-delete" (click)="deleteClick()">
                                <i class="far fa-trash-alt" aria-hidden="true"></i> Excluir
                            </a>
                        </ng-template>
                        
                    </div>
                </div>            
            </div>
        </div>
    
        <div class="card-body pipeline-card-body">
            <ul class="list-group pipeline-card-list-group-flush">
                <li class="list-group-item list-group-item-nome">
                    {{entity.nome}}
                </li> 

                <ng-template [ngIf]="!config?.isSemCampanha">
                    <li class="list-group-item" *ngIf="entity.idPacoteCampanha">
                        <sgt-pacote-campanha-label
                            [nome]="entity.nomePacoteCampanha"
                            fontSize="10px">
                        </sgt-pacote-campanha-label>
                    </li>

                    <li class="list-group-item" *ngIf="entity.resultado?.quantidadePedidosVendasNaoLiberados > 0 || entity.resultado?.quantidadePedidosBonificacoesNaoLiberados > 0">
                        <sgt-campanha-pedido-nao-liberado-pipeline-card
                            [idCampanha]="entity.id"
                            [filter]="filter">
                        </sgt-campanha-pedido-nao-liberado-pipeline-card>
                    </li>
                </ng-template>

                <li class="list-group-item list-group-item-roi">
                    <sgt-campanha-roi-pipeline-widgets
                        [roi]="entity.resultado?.roi">
                    </sgt-campanha-roi-pipeline-widgets>
                </li>
            </ul>
            
    
            <ng-template [ngIf]="!config?.isSemCampanha">
                <div class="pipeline-card-toggle-button">
                    <button type="button" class="btn btn-link" (click)="toggleCollapse()">
                        <i class="fas fa-chevron-down" *ngIf="!entity.pipelineCard?.isCollapseOpened"></i>
                        <i class="fas fa-chevron-up" *ngIf="entity.pipelineCard?.isCollapseOpened"></i>
                    </button>
                </div>
                
                <div class="collapse" [class.show]="entity.pipelineCard?.isCollapseOpened" #collapse>
                    <div class="collapse-content">
                        <ul class="list-group pipeline-card-list-group-flush">   
                            <li class="list-group-item">
                                <sgt-campanha-pipeline-card-info-status
                                    [campanha]="entity">
                                </sgt-campanha-pipeline-card-info-status>
                            </li>                            
                            <li class="list-group-item">
                                <span class="list-group-item-title">
                                    Objetivos
                                </span>
                                <span class="list-group-item-value">
                                    <sgt-objetivo-campanha-badges
                                        [objetivoVenda]="entity.objetivoVenda"
                                        [objetivoBonificacao]="entity.objetivoBonificacao"
                                        [objetivoAquisicao]="entity.objetivoAquisicao"
                                        title="Objetivos da Campanha"
                                        fontSize="10px">
                                    </sgt-objetivo-campanha-badges>
                                </span>
                            </li>  
                            <li class="list-group-item list-group-item-cupons" *ngIf="entity.cupons && entity.cupons.length > 0">
                                <span class="list-group-item-title">
                                    <i class="fas fa-tags"></i> Cupons
                                </span>
                                <span class="list-group-item-value">
                                    <span class="badge badge-primary" *ngFor="let cupon of entity.cupons">
                                        {{cupon}}
                                    </span>
                                </span>
                            </li>                                                                   
                            <li class="list-group-item" title="Descrição da campanha" *ngIf="entity.descricao">
                                <span class="list-group-item-title">
                                    Descrição
                                </span>
                                <span class="list-group-item-value">
                                    {{entity.descricao}}
                                </span>
                            </li>           
                        </ul>                    
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>